import {useEffect, useState} from "react";
import TemporaryDrawer from "../ui/temp-drawer.component";
import {GemsIcon} from "../ui/gems-icon";
import {CoinIcon} from "../ui/coin-icon";
import {ChequeredFlagIcon} from "../ui/chequered-flag-icon";
import {enableBodyScroll} from "../../utils/HtmlHelper";
import {useNavigate} from "react-router-dom";
import {LeagueType} from "./league.component";
import {useGetTournamentRequirementsQuery} from "../../apis/tournaments.api";

export interface LeagueRequirementInterface {
  type: string,
  label: string,
  goal: number,
  value: number,
  infoText: string,
  completed: boolean
}

const BRONZE_LEAGUE_REQUIREMENT = [
  {
    type: "rank",
    label: "TOP 10 Player",
    goal: 10,
    value: 21,
    infoText: "Continue to play to improve your rank.",
    completed: false,
  },
  {
    type: "collectible",
    label: "Bronze Collectible cards",
    goal: 5,
    value: 2,
    infoText: "Unlock more Bronze Collectible cards.",
    completed: false,
  }
];

interface LeagueRequirementsProps {
  // requirements : any;
  league: LeagueType,
  leagueRank: number
}

const LeagueRequirements: React.FC<LeagueRequirementsProps> = ({league, leagueRank}) => {

  const navigate = useNavigate();


  const {data: leagueRequirement, isLoading: isLeagueRequirementLoading} = useGetTournamentRequirementsQuery({
    league,
    leagueRank
  });

  console.log('leagueRequirement: ', leagueRequirement);

  // const requirements = BRONZE_LEAGUE_REQUIREMENT;
  const requirements = leagueRequirement || [];

  const [requirementListElement, setRequirementListElement] = useState<any>(null);

  useEffect(() => {

    setRequirementListElement(requirements.map((requirement: any, index: number) =>
      <LeagueRequirement
        key={index}
        type={requirement.type}
        label={requirement.label}
        goal={requirement.goal}
        value={requirement.value}
        infoText={requirement.infoText}
        completed={requirement.completed}
      />
    ));

  }, [leagueRequirement]);


  let displayCollectiblesCTA = false;

  for (let index = 0; index < requirements.length; index++) {
    const requirement = requirements[index];
    if (requirement.type == 'collectible' && requirement.value < requirement.goal) {
      displayCollectiblesCTA = true;
    }
  }
  console.log('displayCollectiblesCTA: ', displayCollectiblesCTA);

  return (

    <div className="flex flex-col justify-center w-full gap-5 pb-5">

      <p className="text-xl center"> Next League requirements </p>

      <div>
        {requirements.map((requirement: any) =>
          <p
            className={`center font-medium text-gray-700 ${requirement.completed ? 'hidden' : ''} `}>{requirement.infoText}</p>
        )}
      </div>

      <div className="flex flex-col gap-5">
        {requirementListElement}
      </div>

      <button className={`primary ${displayCollectiblesCTA ? 'mt-4' : '!hidden'}`}
              onClick={() => {
                enableBodyScroll();
                navigate(`/collectibles`);
              }
              }>
        View my collectibles
      </button>

    </div>

  );
}

export default LeagueRequirements;


interface LeagueRequirementProps {
  type: string,
  label: string,
  goal: number,
  value: number,
  infoText: string,
  completed: boolean
}

const LeagueRequirement: React.FC<LeagueRequirementProps> = ({
                                                               type, label, goal, value, infoText, completed
                                                             }) => {
  return (
    <div
      className={`min-h-[68px] flat-card flex gap-2 ${completed ? '!border-orange border-2 shadow-none' : ''}`}>

      <div className="flex-none content-center">
        {
          type == "rank" ? <ChequeredFlagIcon h={32}/> :
            <img className="w-8" src={`${process.env.REACT_APP_STATIC_ASSETS}/images/collectible-card.png`}/>
        }
      </div>

      <div className="flex-auto content-center">
        <p className="font-bold text-xs">
          {label}
        </p>
        {/* <p className="font-normal text-xs text-opacity-60"> {step == 5 ? `You referred ${goal} new ${ goal > 1 ? 'friends': 'friend' }` : `Invite ${goal} friends to unlock` } </p> */}
      </div>

      <div className="flex-none content-center">

        <div
          className={`p-2 rounded-md text-sm font-bold ${completed ? '!border-orange border shadow-none text-orange' : 'bg-orange text-white border border-opacity-10 border-black'}`}>
          {type == "rank" &&
            <span># {value}</span>
          }
          {type == "collectible" &&
            <span>{value} / {goal}</span>
          }
        </div>

      </div>

    </div>
  );
}

// export default Requirement;